// Custom components
import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/MyTooltip";
import CicleExclamationIcon from "components/icons/CicleExclamationIcon";

function InputField(props) {
    const {
        label,
        name,
        extra,
        placeholder,
        cols,
        rows,
        state,
        disabled,
        required = false,
        value,
        onChange,
        error,
        tooltip,
    } = props;

    return (
        <div className={`${extra}`}>
            {tooltip ? (
                <Tooltip>
                    <TooltipTrigger>
                        <label
                            htmlFor={name}
                            className={`text-sm font-medium text-gray-700 dark:text-white`}
                        >
                            {label}
                        </label>
                    </TooltipTrigger>

                    <TooltipContent>
                        <div className="-mx-2 flex items-stretch">
                            <div className="mx-2 shrink-0 self-center text-amber-500">
                                <CicleExclamationIcon />
                            </div>
                            <p className="mx-2 flex-1 dark:text-white">
                                {tooltip}
                            </p>
                        </div>
                    </TooltipContent>
                </Tooltip>
            ) : (
                <label
                    htmlFor={name}
                    className={`text-sm font-medium text-gray-700 dark:text-white`}
                >
                    {label}
                </label>
            )}
            <div>
                <textarea
                    cols={cols}
                    rows={rows}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    defaultValue={value}
                    className={`mt-2 flex w-full items-center justify-center rounded-[8px] border bg-white/0 pl-3 pt-3 text-sm outline-none ${
                        disabled === true
                            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                            : state === "error"
                            ? "!border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                            : state === "success"
                            ? "!border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                            : disabled === true
                            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                            : "border-gray-200 dark:!border-white/10 dark:text-white"
                    }`}
                    name={name}
                ></textarea>
                {error
                    ? error.map((message) => {
                          return (
                              <small className="mb-1px block text-red-500">
                                  {message}
                              </small>
                          );
                      })
                    : null}
            </div>
        </div>
    );
}

export default InputField;
